
import { API } from '@/services/api.service'

const name = 'privacy_policy'

export default {
  name: 'PrivacyPolicy',

  head () {
    const title = this.$t('pages.privacyPolicy.seo.title')
    const description = this.$t('pages.privacyPolicy.seo.metaDescription')
    return {
      title,
      meta: [
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'twitter:title', name: 'twitter:title', content: title },

        { hid: 'description', name: 'description', content: description },
        { hid: 'og:description', property: 'og:description', content: description },
        { hid: 'twitter:description', name: 'twitter:description', content: description },
      ]
    }
  },

  data () {
    return {
      content: ''
    }
  },
  async asyncData ({ error }) {
    try {
      const { data } = await API.get(`/static-pages/${name}`)
      return { content: data.staticPage.content }
    } catch (e) {
      error({ statusCode: 500, message: 'Failed to load privacy policy' })
    }
  }
}
